import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { CreateQAPair } from "../../API/api";
import { useDispatch, useSelector } from "react-redux";
import "../../Component/SearchInput/searchInputStyles.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "./NewKnowledgeEntryPageStyles.module.css";
import { dateFormater, filterDomainsForComponent2 } from "../../utils";
import { Button, Switch } from "antd";
import TextEditor from '../../NewComponent/NewEditor/KnowledgeEntrySearchResult/TextEditor'
import Tooltip from '@mui/material/Tooltip';
import { expireDateFormater } from "../../utils";
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import Layout from "../../NewComponent/LayoutExpert/Layout";
import NewGenerateQA from "../../NewComponent/GenerateQA/NewGenerateQA";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { Checkbox } from 'antd';
import { ReactComponent as Internal } from "./../../Icons/internal.svg";
import ExpertSearchBar from "../../NewComponent/NewEditor/ExpertSearchBar";
import SelectComp from "../../NewComponent/Select/Select";
import internalIcon from '../../Icons/internal.svg'
import SwitchComp from "../../NewComponent/Switch/Switch";

export default function NewKnowledgeEntryPage() {
  const containerStyles = {
    width: "80%",
    margin: "auto",
    // marginTop:"1%",
    // marginTop: "6%",
    marginBottom: "7%",
    border: '1px solid #EAECF0',
    boxShadow: '0px 4px 16px 0px #1018280F',
    borderRadius: '12px',
    // minHeight:'450px',
    padding: '0px 24px 24px 24px',
    Height: "100%"
  };
  const containerStyles1 = {
    width: "80%",
    margin: "auto",
    padding: '0px 24px 0px 0px',
  };
  
  const onSelectedTabStyles = {
    textAlign: "center",
    borderBottom: "2px solid",
    borderImage: "linear-gradient(90.39deg, #00D  1FF 0.34%, #0075FF 99.7%) 1",
    paddingBlock: "15px",
    fontSize: "16px",
    lineHeight: "24px",
    cursor: "pointer",
    fontWeight: "400",
    background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    msTextFillColor: "transparent",
    OTextFillColor: "transparent",
    width:"10%",
    marginLeft: "10px",
  };
  const onSelectedTabStyles1 = {
    textAlign: "center",
    borderBottom: "2px solid",
    borderImage: "linear-gradient(90.39deg,rgb(237, 238, 240) 0.34%,rgb(237, 238, 240) 99.7%) 1",
    paddingBlock: "15px",
    fontSize: "22px",
    lineHeight: "24px",
    cursor: "pointer",
    fontWeight: "400",
    // background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    msTextFillColor: "transparent",
    OTextFillColor: "transparent",
    width:"90%",
    // marginLeft: "10px",
  };
  const textStyles2 = {
    fontSize: "18px",
    color: "#2A364A",
    lineHeight: "22px",
    fontWeight: "300",
    display: 'flex',
    alignItems: "center",
  };
  const textStyles = {
    fontSize: "14px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const textStyles3 = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "22px",
    fontWeight: "300",
    display: 'flex',
    alignItems: "center",
  };
  const textStyles1 = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
    paddingTop: "10px",

  };
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [additionalDetails, setAdditionalDetails] = useState("");
  const [domains, setDomains] = useState(null);
  const [internal, setInternal] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [files, setFiles] = useState([]);
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();
  const onChangeQuestion = (e) => {
    setQuestion(e.target.value);
  };
  const userState = useSelector((state) => state.user);
  const generateQAState = useSelector((state) => state.generateQA);
  const editorState = useSelector((state) => state.editor)
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [val, setVal] = React.useState(1);
  const currentRoute = useLocation();
  const [KBExpirationdate, setKBExpirationdate] = useState(expireDateFormater(userState.expirationMonths));
  const handleChange = (event, newValue) => {
    setVal(newValue);
  };
  const dispatch = useDispatch();
  const { updateExpirationDateForEditor, switchToggleGQA } = bindActionCreators(Actions, dispatch)

  const onChangeAnswer = (str) => {
    setAnswer(str);
  };

  const onAppendStapleAnswer = (str) => {
   
  
    let newStr;
  
    if (typeof str === "string") {
      newStr = answer.concat(str);
    } else if (typeof str === "object" ) {
  
      newStr = answer.concat(str.answerText);
    } else {
      console.error("Invalid input: str must be a string or an object with 'answerCopy' property");
      return;
    }
  
    setAnswer(newStr);
  };

  
  const onChangeFiles = (str) => {
    let data = files;
    data.push(str);
    setFiles(data);
    let newStr = answer + '<p></p>';
    onChangeAnswer(newStr);
  };
  const removeAttachment = (data) => {
    let newData = files.filter(att => {
      if (att.name !== data.name) {
        return att;
      }
    });
    setFiles(newData);
  }
  const onChangeAdditionalDetails = (e) => {
    setAdditionalDetails(e.target.value);
  };

  const onChangeDomain = (e) => {
    // console.log('onchange', e.toString())
    setDomains(e);
  };

  const handleCheckInternal = (e) => {
    setInternal(e.target.checked);
  };

  const handleCheckPrivacy = (e) => {
    setPrivacy(e.target.checked);
  };
  const qaPairSuccessToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const createQAPair = () => {
    const payload = {
      additionalContext: additionalDetails,
      answer: answer,
      domain: domains,
      question: question,
      uplodedFiles: files,
      internal: internal,
      privacy: privacy,
      expirationDate: "",
    };
    CreateQAPair(payload).then((res) => {
      if (res === undefined) return;
      if (res.data.success === true || res.data.data !== "") {
        setQuestion("");
        setAnswer("");
        setAdditionalDetails("");
        setDomains("");
        setInternal("");
        setPrivacy("");
        toast.success(qaPairSuccessToast(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        navigate(-1);
      }
    })
  }
  useEffect(() => {
    updateExpirationDateForEditor(expireDateFormater(userState.expirationMonths));
  }, [files])
  // var oneYearFromNow = new Date();
  // oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
  // var nextYearDate = moment(oneYearFromNow).format("YYYY-MM-DD");

  const onChangeDateFormat = (e) => {
    setKBExpirationdate(e.target.value)
  }


  return (
    <>
      <Layout>
     
        		<div style={containerStyles1} className="midBlockNew">
              <h3 className="backButtonNew">
                <div style={{display:'flex'}} onClick={() => navigate(-1)}>
                  <i
                    className="fa fa-arrow-left"
                    aria-hidden="true"
                    style={{
                      padding: "3px",
                      fontSize: "20px",
                      paddingRight: "7px",
                    }}
                  ></i>
                  <span>Back</span>
                </div>
              </h3>
            </div>
        <div style={containerStyles}>
          <div style={{ display: 'flex', alignItems: "center", marginTop: "6pxpx" }} >
            <span style={textStyles1}>Create Q&A&nbsp;</span>
            <span style={textStyles1}>
              {/* <Switch value={generateQAState.toggle} onChange={(e) => switchToggleGQA(e)}/> */}
              {/* <SwitchComp value={generateQAState.toggle} onChangeFunc={(e) => switchToggleGQA(e)}/> */}
              {/* <VizToggleSwitch/> */}
              <Switch style={{background:'var(--light_color_shade)'}}   value={generateQAState.toggle} onChange={(e) => switchToggleGQA(e)} />

            </span>
            <span style={textStyles1}>&nbsp;Generate Q&A</span></div>

          {generateQAState.toggle && <div style={{ marginTop: "-1%" }}>
            <NewGenerateQA />

          </div>

          }
          {!generateQAState.toggle &&
            <>
              <div style={{ display: "flex", gap: "5px", marginTop: "10px" }}>
                {/* <p style={textStyles2}>
                  Want to search for existing records before you create new Q&A?
                </p> */}
              </div>
              <Box sx={{ flexGrow: 1 }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid item xs={12}>
                    <span style={textStyles}>New Question&nbsp; </span>
                  </Grid>
                  <Grid item xs={12} spacing={2} mb={1}>
                    {/* <textarea
                    value={question}
                    onChange={(e) => onChangeQuestion(e)}
                    minRows={3}
                    style={{
                      width: "100%",
                      outline: "none",
                      borderColor: "#ccc",
                      borderRadius: "6px",
                    }}
                  /> */}
                    <textarea wrap="soft" style={{ border: '1px solid rgb(224, 226, 230)', width: '100%', padding: '12px', borderRadius: '6px', outline: 'none' }} rows={1} type={"text"}
                      value={question}
                      onChange={(e) => onChangeQuestion(e)}
                      minRows={2} />

                  </Grid>
                  <Grid item xs={12} spacing={2}>
                    <span style={textStyles}>Domain (Optional)&nbsp; </span>
                  </Grid>
                  <Grid item xs={12} spacing={2} mb={1}>
                    <SelectComp  placeholder="Select Domain" val={domains} onChangeFunc={onChangeDomain} width={'100%'} size={'medium'} isString={false}
                      options={filterDomainsForComponent2(userState.visibleTopics)}
                    />

                  </Grid>
                  <Grid item xs={12} spacing={2}>
                    <span style={textStyles}>
                      Additional Details (Optional)&nbsp; 
                    </span>
                  </Grid>
                  <Grid item xs={12} spacing={2}>

                    <textarea wrap="soft" style={{ border: '1px solid rgb(224, 226, 230)', width: '100%', padding: '12px', borderRadius: '6px', outline: 'none' }} rows={1} type={"text"}
                      value={additionalDetails}
                      onChange={(e) => onChangeAdditionalDetails(e)}
                      minRows={2}
                    />
                  </Grid>
                  <Grid item xs={12} spacing={2}>
                    <span style={textStyles}>Your Answer&nbsp; </span>
                    <TextEditor
                      value={answer}
                      onChangeFileFunc={onChangeFiles}
                      onChangeFunc={onChangeAnswer}
                    />
                  </Grid>
                  <Grid container spacing={2} style={{ paddingTop: "5px" }}>
                    <Grid item xs={4}>

                      <span style={textStyles}>Expiration Date&nbsp; <input type="date" style={{ marginLeft: "4px" }}
                        id="dateKnowledgeEntry" min={dateFormater()} value={KBExpirationdate} onChange={(e) => onChangeDateFormat(e)} /></span>

                    </Grid>
                    <Grid
                      item
                      sx={{
                        color: "var(--questionText_color)",
                        padding: "0",
                      }}
                      container
                      xs={8}
                      justifyContent="flex-end"
                      spacing={1}
                      mt={0.2}
                    >


                      <div style={textStyles3}>
                        <Checkbox checked={internal}
                          onChange={(e) => handleCheckInternal(e)}
                          type="checkbox" />&nbsp;
                        <img src={internalIcon} />&nbsp;Internal Only&nbsp;

                        {/* Internal Only

                        <Internal /> */}
                        <TooltipComp title="This QA pair will be visible only to Employees and not to Customers & Partners.">
                          <i className='fa fa-question-circle tooltip-topics-b' ></i>
                        </TooltipComp>

                      </div>&nbsp;&nbsp;&nbsp;&nbsp;

                      <div style={textStyles3}>
                        <Checkbox checked={privacy}
                          onChange={(e) => handleCheckPrivacy(e)}
                          type="checkbox" />&nbsp;<i className="fa fa-lock"></i>&nbsp;Private Answer&nbsp;
                        <TooltipComp title='This answer will be visible only to the Seeker who asked the question, and to all Experts.'>
                          <i className='fa fa-question-circle tooltip-topics-b'></i>
                        </TooltipComp>
                      </div>


                    </Grid>
                  </Grid>
                  <div style={{ display: 'flex', marginTop: "5px" }} >
                    <div style={{ width: "85%" }}>
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {
                          files.map((attchmnt) => {
                            return (
                              <div className='attachmentsName'>
                                <Tooltip>
                                  {attchmnt.name}
                                  <span>
                                    &nbsp;
                                    <i
                                      className="fa fa-close"
                                      style={{
                                        cursor: "pointer",
                                        color: "var(--light_color_shade)",
                                      }}
                                      onClick={() => removeAttachment(attchmnt)}
                                    ></i>
                                  </span>
                                </Tooltip>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div style={{ width: '15%', textAlign: 'end' }}>
                      {/* disabled */}
                      <Button
                        style={{
                          padding: '8px 12px 8px 12px',
                          borderRadius: '6px',
                          fontSize: '14px',
                          lineHeight: '24px',
                          fontWeight: 400,
                          boxShadow: '0px 1px 2px 0px #1018280D',
                          color: '#FFFFFF',
                          border: '1px solid  #fff',
                          height: '40px',
                          minWidth: '88px',
                          background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                          marginBottom: '14px'
                        }}
                        onClick={() => createQAPair()}

                        disabled={question === "" || answer === "" ? true : false}
                        className="saveButton"
                      >
                        <i
                          className="fa fa-send"
                          style={{ marginRight: "5px" }}
                        ></i>
                        Submit
                      </Button>


                    </div>
                  </div>
                </Box>

                <div className="mt-3 mb-5">
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      // marginBottom: "20px",
                   width:"100%"

                    }}
                  >
                    <div
                      style={onSelectedTabStyles}
                    >
                      Search&nbsp;
                    </div>
                     <div style={onSelectedTabStyles1}></div>

                  </div>



                  {val === 1 && <>
                    <div style={{ paddingBottom: "15px" }}>
                      <ExpertSearchBar onChangeFunc={onAppendStapleAnswer} createQa={true} />
                    </div>


                    {/* <SearchInput onChangeFunc={onAppendStapleAnswer} /> */}
                  </>}
                </div>


              </Box>
            </>}
        </div>

      </Layout>



    </>
  );
}
